import React, { useEffect } from 'react';
import { Hero } from './components/sections/Hero';
import { IntroOffer } from './components/sections/IntroOffer';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Recognize } from './components/sections/Recognize';
import { Volumes } from './components/sections/Volumes';
import { Tools } from './components/sections/Tools';
import { Bonuses } from './components/sections/Bonuses';
import { ValueStack } from './components/sections/ValueStack';
import { PurchaseTerms } from './components/sections/PurchaseTerms';
import { Testimonials } from './components/sections/Testimonials';
import { Educator } from './components/sections/Educator';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="3mjg93j4va5l5">
      <Hero data-id="element-1" data-mp="3rdkgu4lyihna" />
      <main data-id="element-2" data-mp="3rd1all5o5hp3">
        <IntroOffer data-id="element-3" data-mp="3recctgjguhe3" />
        <Problem data-id="element-4" data-mp="5osn3wyp084" />
        <BeforeAfter data-id="element-5" data-mp="67z9oh5w26u" />
        <Recognize data-id="element-6" data-mp="4n5w26l2pak" />
        <Volumes data-id="element-7" data-mp="56l3b4umzkw" />
        <Tools data-id="element-8" data-mp="7stfczkdj46" />
        <Bonuses data-id="element-9" data-mp="2zld2xbxu5jcl" />
        <ValueStack data-id="element-10" data-mp="2zlv84y2h77wn" />
        <PurchaseTerms data-id="element-11" data-mp="2zmemy5wtxg6g" />
        <Testimonials data-id="element-12" data-mp="2zn6b4vo3kbmp" />
        <Educator data-id="element-13" data-mp="33morde4z3yj7" />
        <FAQ data-id="element-14" data-mp="33m5e4aq9pybi" />
        <FinalCTA data-id="element-15" data-mp="33nq4do5juv3k" />
      </main>
      <Footer data-id="element-16" data-mp="33myix65o2dr0" />
      <FloatingCTA data-id="element-17" data-mp="33oi1x4ipj2wh" />
      <PurchasePopup data-id="element-18" data-mp="38m1f013o59mu" />
    </div>;
}